export const getThumbnailUrl = (thumbName: string) => {
  return `${import.meta.env.VITE_API_URL}/render/thumbnails/web/${thumbName}`;
};

export const getAgcoThumbnailUrl = (thumbName: string) => {
  return `${import.meta.env.VITE_API_URL}/render/thumbnails/web/${thumbName}`;
};

export const getPdfUrl = (pdfName: string, brand: string) => {
  return `${import.meta.env.VITE_API_URL}/uploads/pdfs/${brand}/${pdfName}`;
};

export const getUserLogoUrl = (imageName: string) => {
  return `${import.meta.env.VITE_API_URL}/uploads/brands/${imageName}`;
};

export const getSupplierLogoUrl = (imageName: string) => {
  return `${import.meta.env.VITE_API_URL}/uploads/logos/${imageName}`;
};

export const getSupplierLogoPreviewUrl = (imageName: string) => {
  return `${import.meta.env.VITE_API_URL}/uploads/brands/${imageName}`;
};

export const getProductImageUrl = (imageName: string) => {
  return `${import.meta.env.VITE_API_URL}/uploads/product_images/${imageName}`;
};

export const getCatalogImageUrl = (imageName: string) => {
  return `${import.meta.env.VITE_API_URL}/uploads/page_bgrounds/${imageName}`;
};

export const getCatalogPdfUrl = (pdfName: string) => {
  return `${import.meta.env.VITE_API_URL}/uploads/pdf/base_catalogs/${pdfName}`;
};

export const getRenderPdfUrl = (pdfName: string, brand: string) => {
  return `${import.meta.env.VITE_API_URL}/render/pdfs/${brand}/${pdfName}`;
};

export const getRenderThumbUrl = (thumbName: string) => {
  return `${import.meta.env.VITE_API_URL}/render/thumbnails/${thumbName}`;
};
